import React, { useState, useEffect } from "react";
import Layout from "../containers/layout";
import {
  Page,
  Card,
  Text,
  BlockStack,
  TextField,
  Select,
  Button,
  Box,
  Toast,
} from "@shopify/polaris";

const Reorder = () => {
  const [loading, setLoading] = useState(false);
  const [orderId, setOrderId] = useState("");
  const [referenceId, setReferenceId] = useState("");
  const [selectedStore, setSelectedStore] = useState("Iplanet One");

  const [toast, setToast] = useState(null);
  const showToast = (tone, message) => {
    setToast({ tone, message });
    setTimeout(() => setToast(null), 5000);
  };

  const apiurl = "https://api.iplanet.one";

  const stores = [
    { label: "Iplanet One", value: "Iplanet One" },
    { label: "Nexus Mall", value: "Nexus Mall" },
    { label: "Indigo", value: "Indigo" },
  ];

  const OrderHandler = async () => {
    if (!orderId.trim()) {
      showToast("warning", "Order ID is mandatory");
      return;
    }

    setLoading(true);

    const getOrderUrl =
      selectedStore === "Iplanet One"
        ? `${apiurl}/orders/getorder`
        : selectedStore === "Nexus Mall"
          ? `${apiurl}/nexus/orders/getorder`
          : `${apiurl}/indigo/orders/getorder`;

    try {
      const response = await fetch(getOrderUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ orderid: orderId }),
      });

      const data = await response.json();

      if (data.success) {
        await initOrder(data.data.order);
      } else {
        showToast("critical", "Order Not Found");
      }
    } catch (error) {
      console.error(error);
      showToast("critical", "Failed to fetch order");
    } finally {
      setLoading(false);
    }
  };

  const initOrder = async (data) => {
    const orderPushUrl =
      selectedStore === "Iplanet One"
        ? `${apiurl}/wondersoft/createsaledorder`
        : selectedStore === "Nexus Mall"
          ? `${apiurl}/nexus/wondersoft/v2/createsalesorder`
          : `${apiurl}/indigo/wondersoft/v2/createsalesorder`;

    const url = `${orderPushUrl}${
      referenceId ? `?paymentid=${referenceId}` : ""
    }`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (result?.message === "ok") {
        showToast("success", "Order Pushed Successfully");
      } else {
        showToast("critical", "An error occurred");
      }
    } catch (error) {
      console.error("Error pushing order:", error);
      showToast("critical", "Error occurred");
    }
  };

  return (
    <Layout>
      <Page fullWidth>
        <BlockStack gap="600" align="center">
          <Card padding="600" maxWidth="900px">
            <BlockStack gap="500" align="center">
              <BlockStack gap="200" align="center">
                <Text variant="heading2xl" as="h1" alignment="center">
                  Re Order
                </Text>
                <Text variant="bodyMd" tone="subdued" alignment="center">
                  Use order ID to push the order to Wondersoft
                </Text>
              </BlockStack>

              <Card background="bg-surface-secondary" rounded="300">
                <Box padding="400">
                  <BlockStack gap="400">
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "1rem",
                        alignItems: "end",
                      }}
                    >
                      <TextField
                        label="Order ID"
                        value={orderId}
                        onChange={setOrderId}
                        placeholder="Enter Order ID"
                        autoComplete="off"
                        disabled={loading}
                      />

                      <TextField
                        label="Payment Reference ID (optional)"
                        value={referenceId}
                        onChange={setReferenceId}
                        placeholder="Enter Reference ID"
                        autoComplete="off"
                        disabled={loading}
                      />

                      <Select
                        label="Store"
                        options={stores}
                        onChange={setSelectedStore}
                        value={selectedStore}
                        disabled={loading}
                      />

                      <Button
                        variant="primary"
                        size="large"
                        onClick={OrderHandler}
                        loading={loading}
                        disabled={loading}
                      >
                        Push Order
                      </Button>
                    </Box>
                  </BlockStack>
                </Box>
              </Card>
              {toast && (
                <Toast
                  content={toast.message}
                  tone={toast.tone}
                  onDismiss={() => setToast(null)}
                />
              )}
            </BlockStack>
          </Card>
        </BlockStack>
      </Page>
    </Layout>
  );
};

export default Reorder;
